module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-6.60aba702.svg";